module.exports = __webpack_public_path__ + "static/media/jacket-4.6f11f380.jpg";